import { Group, NativeSelect } from "@mantine/core";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { FxIdWebFeaturesPlayOtaGameVersion, FxIdWebFeaturesProfileGetResponseFeature } from "../../../../../Api/gen";
import { useGamePlayListQuery, useProfileDataQuery } from "../../../../../Api/Queries";
import { useBuildNumber, useOtaVersion } from "../../../Hooks";

export const VersionSelectSection = () => {
	const { data } = useProfileDataQuery({ staleTime: Infinity });
	if (!data?.Features.includes(FxIdWebFeaturesProfileGetResponseFeature.ListGames)) return null;
	if (import.meta.env.VITE_APP_ENV_OVERRIDE_NAME === "prod") return null;
	return (
		<StorageGuard>
			<VersionSelect />
		</StorageGuard>
	);
};

const StorageGuard = (props: { children: React.ReactNode }) => {
	const { game } = useParams();
	const [otaVersion, setOtaVersion] = useOtaVersion();
	const [buildNumber, setBuildNumber] = useBuildNumber();
	const { data } = useGamePlayListQuery(
		{ game, otaVersion },
		{
			onSuccess: (data) => {
				if (buildNumber !== null || data.Builds.length === 0) return;
				setBuildNumber(data.Builds[0].BuildNumber);
			}
		}
	);

	useEffect(() => {
		if (otaVersion !== null) return;
		setOtaVersion(FxIdWebFeaturesPlayOtaGameVersion.Development);
	}, [otaVersion, setOtaVersion]);

	if (otaVersion === null || !data) return null;
	return <>{props.children}</>;
};

const VersionSelect = () => {
	const { game } = useParams();
	const [otaVersion, setOtaVersion] = useOtaVersion();
	const [buildNumber, setBuildNumber] = useBuildNumber();
	const { data: buildsData } = useGamePlayListQuery({ game, otaVersion });
	const gameVersions = Object.keys(FxIdWebFeaturesPlayOtaGameVersion).filter((k) => isNaN(Number(k)));
	return (
		<Group>
			<NativeSelect
				label="Version"
				wrapperProps={{ sx: { display: "flex", alignItems: "baseline", gap: 5 } }}
				labelProps={{ sx: { color: "white" } }}
				h={24}
				size="xs"
				data={gameVersions}
				value={otaVersion ?? ""}
				onChange={(e) => {
					setOtaVersion(e.target.value);
					setBuildNumber(null);
					window.location.reload();
				}}
				styles={{ input: { minHeight: 24, height: 24, lineHeight: "24px" } }}
			/>
			{(buildsData?.Builds.length ?? 0) > 0 && (
				<NativeSelect
					label="Build"
					labelProps={{ sx: { color: "white" } }}
					wrapperProps={{ sx: { display: "flex", alignItems: "baseline", gap: 5 } }}
					h={24}
					size="xs"
					value={buildNumber ?? ""}
					onChange={(e) => {
						setBuildNumber(Number(e.target.value));
						window.location.reload();
					}}
					data={buildsData?.Builds.map((b) => String(b.BuildNumber)) ?? []}
					styles={{ input: { minHeight: 24, height: 24, lineHeight: "24px" } }}
				/>
			)}
		</Group>
	);
};
